import { SingleColorType } from '../../types';

const SET_BACKGROUND_COLOR = 'SET_BACKGROUND_COLOR';
type SET_BACKGROUND_COLOR = typeof SET_BACKGROUND_COLOR;

export interface ISetBackgroundColor {
    type: SET_BACKGROUND_COLOR;
    payload: SingleColorType;
}

export function setBackgroundColor(
    color: SingleColorType
): ISetBackgroundColor {
    return {
        type: SET_BACKGROUND_COLOR,
        payload: color,
    };
}
